/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type GoalDetailsNextReview_goal = {
    readonly nextReviewAt: string;
    readonly " $refType": "GoalDetailsNextReview_goal";
};
export type GoalDetailsNextReview_goal$data = GoalDetailsNextReview_goal;
export type GoalDetailsNextReview_goal$key = {
    readonly " $data"?: GoalDetailsNextReview_goal$data;
    readonly " $fragmentRefs": FragmentRefs<"GoalDetailsNextReview_goal">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "GoalDetailsNextReview_goal",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "nextReviewAt",
      "storageKey": null
    }
  ],
  "type": "Goal",
  "abstractKey": null
};
(node as any).hash = '8171e86e8d6184eda46ff92b6f926caf';
export default node;
